// src/App.jsx
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Login from "./components/Login/login";
import ProtectedRoute from "./components/ProtectedRoute";
import MCQPractice from "./components/MCQ";
import GoogleDocViewer from "./components/Doc";
import MainLayout from "./components/Layout/MainLayout";
import Home from "./components/Home/home";
import SessionsData from "./components/Sessions/sessions";
import VideoPlayer from "./components/VideoPlayer/videoplayer";
import CourseMain from "./components/CourseWelcome/CourseMain";
import StudentProfileMainPage from "./studentProfile/StudentMainPage";

const App = () => {
  return (
    <div className="App">
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<CourseMain />} />
        {/* PROTECTED ROUTES WITH LAYOUT */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* Home Page */}
          {/* <Route index element={<Home />} /> */}

          {/* Other Pages */}
          <Route path="course" element={<Home />} />
          <Route path=":gc" element={<SessionsData />} />
          <Route path=":gc/mcq/:id" element={<MCQPractice />} />
          <Route path="doc/:id" element={<GoogleDocViewer />} />
          <Route path="project/:id" element={<VideoPlayer />} />
          <Route path="profile" element={<StudentProfileMainPage />} />
          <Route path="profile/:tab" element={<StudentProfileMainPage />} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;
